import {createTheme} from "@mui/material";
// Brings the x-date-pickers component keys (MuiMultiSectionDigitalClockSection etc.)
// into the MUI theme typings so they can be styled from `components` below. Types only -
// a value import would break the Vite dep pre-bundle, the module ships no runtime code.
import type {} from "@mui/x-date-pickers/themeAugmentation";

export const cStylesPaymentInfo = {
    content: {
        width: '80%',
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        marginTop: "30px",
        transform: 'translate(-50%, -50%)',
        backgroundColor: 'rgba(0,0,0,0.7)',
        color: 'white',
    },
    overlay: {
        zIndex: '20',
    },
};

export const cStylesApp = {
    content: {
        width: 'auto',
        minWidth: '200px',
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: 'rgba(0,0,0,0.7)',
        color: 'white',
    },
    overlay: {
        zIndex: '20',
    },
};

export const cStylesMakeRes = {
    content: {
        width: 'auto',
        minWidth: '200px',
        maxWidth: '769px',
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: 'rgba(0,0,0,0.7)',
        color: 'white',
        textAlign: 'center',
    },
    overlay: {
        zIndex: '20',
    },
};

export const cStylesFilters = {
    content: {
        width: 'calc(100% - 20px)',
        maxHeight: 'calc(100% - 10px)',
        overflowY: 'auto',
        scrollbarWidth: 'none',
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: 'rgba(0,0,0,0.7)',
        borderRadius: '30px',
        padding: '10px 0 0 0',
    },
    overlay: {
        zIndex: '1001',
    },
};

export const cStylesPaymentCreatedRes = {
    content: {
        width: '80%',
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        marginTop: "30px",
        transform: 'translate(-50%, -50%)',
        backgroundColor: 'rgba(0,0,0,0.7)',
        color: 'white',
    },
    overlay: {
        zIndex: '20',
    },
};

export const cStylesResponseModal = {
    content: {
        width: '90%',
        maxWidth: '1000px',
        maxHeight: '95%',
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: 'rgba(0,0,0,0.7)',
        color: 'white',
        scroll: 'auto'
    },
    overlay: {
        zIndex: '100',
    },
};

export const cStylesMaps = {
    content: {
        width: '60%',
        top: '55%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: 'rgba(0,0,0,0.7)',
        color: 'white',
    },
    overlay: {
        zIndex: '20',
    },
};

export const yellowTheme = createTheme({
    palette: {
        primary: {
            main: '#fbb040'
        },
    },
    typography: {
        fontFamily: 'inherit', // inherit RRM font family
    },
    components: {
        MuiPopper: {
            defaultProps: {
                style: { zIndex: 99999 },
            },
        },
        MuiDialog: {
            styleOverrides: {
                root: {
                    zIndex: 99999,
                },
            },
        },
        MuiModal: {
            styleOverrides: {
                root: {
                    zIndex: 99999,
                },
            },
        },
        // Hour/minute columns of the time picker (MultiSectionDigitalClock).
        //
        // @mui/x-date-pickers v6 styles each column as `overflow: hidden` and only makes it
        // scrollable on `:hover`. iOS Safari has no hover, it synthesises a sticky :hover state
        // *after* the first tap - so the very first drag lands on a column that is not a scroll
        // container, and the browser passes the gesture to the page behind the popper instead.
        // The user sees the page scroll away rather than the hour list moving, and has to tap
        // once before scrolling works.
        //
        // MUI fixed this in v7 by guarding the :hover rule with `@media (pointer: fine)` and
        // making coarse pointers scrollable unconditionally. This is that fix backported; it can
        // be deleted once we are on @mui/x-date-pickers v7+.
        MuiMultiSectionDigitalClockSection: {
            styleOverrides: {
                root: {
                    '@media (pointer: none), (pointer: coarse)': {
                        overflowY: 'auto',
                        overscrollBehavior: 'contain',
                    },
                },
            },
        },
    },
});

export const cStylesDatepicker = {
    content: {
        width: '80%',
        top: '40%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        marginTop: "30px",
        transform: 'translate(-50%, -50%)',
        backgroundColor: 'rgba(0,0,0,0.7)',
        color: 'white',
    },
    overlay: {
        zIndex: '20',
    },
};